import { useEffect, useContext, Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import AuthProvider, {
  AuthDispatchContext,
  AuthStateContext,
  checkValidity,
} from "contexts/auth";
import { Toaster } from "react-hot-toast";
import Header from "components/header";
import Footer from "components/footer";
import Main from "components/main";
import BottomMenu from "components/bottom-menu";
import FlashScreen from "components/page-loader";
import Typography from "components/core/typography";
import Container from "components/core/container";
import AppFonts from "styled/app-fonts";
import IconFonts from "styled/icon-fonts";
import CSSReset from "styled/reset";
import CommonProvider from "contexts/common";
import { appQueryClient } from "utils/query-client";
import ScrollToTop from "components/scroll-to-top";

const RootWrapper = ({ routesWithoutHeaderFooter }) => {
  const { pathname } = useLocation();
  const { isCheckingValidity } = useContext(AuthStateContext);
  const dispatch = useContext(AuthDispatchContext);

  const canShowHeaderFooter = !routesWithoutHeaderFooter.includes(pathname);

  useEffect(() => {
    checkValidity(dispatch);
  }, [dispatch]);
  if (isCheckingValidity) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Container className="app-container" padding={[0, 0, 0, 0]}>
      {canShowHeaderFooter && <Header />}
      <Main
        className={
          canShowHeaderFooter ? "main-layout-common" : "main-layout-auth"
        }
      >
        <Suspense fallback={<FlashScreen />}>
          <Outlet />
        </Suspense>
      </Main>
      <Footer />
      {canShowHeaderFooter && <BottomMenu />}
    </Container>
  );
};

function Root(props) {
  return (
    <>
      <ScrollToTop />
      <AppFonts />
      <IconFonts />
      <CSSReset />
      <QueryClientProvider client={appQueryClient}>
        <AuthProvider>
          <CommonProvider>
            <RootWrapper {...props} />
            <Toaster position="top-center" reverseOrder={false} />
          </CommonProvider>
        </AuthProvider>
      </QueryClientProvider>
    </>
  );
}

export default Root;
